import { render, staticRenderFns } from "./loading-dialog.vue?vue&type=template&id=50d87a52"
import script from "./loading-dialog.vue?vue&type=script&lang=js"
export * from "./loading-dialog.vue?vue&type=script&lang=js"
import style0 from "./loading-dialog.vue?vue&type=style&index=0&id=50d87a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports